export const GET_PROJECT_SUMMARY_REQUEST = 'GET_PROJECT_SUMMARY_REQUEST';
export const GET_MONTHLY_STATUS_BREAKDOWN_REQUEST = 'GET_MONTHLY_STATUS_BREAKDOWN_REQUEST';
export const GET_UNASSIGNED_SUMMARY_REQUEST = 'GET_UNASSIGNED_SUMMARY_REQUEST';
export const GET_UNASSIGNED_LIST_REQUEST = 'GET_UNASSIGNED_LIST_REQUEST';
export const GET_PROJECT_REQUEST = 'GET_PROJECT_REQUEST';
export const GET_PROJECTS_REQUEST = 'GET_PROJECTS_REQUEST';
export const GET_PROJECT_BILLING_ENTITIES_REQUEST = 'GET_PROJECT_BILLING_ENTITIES_REQUEST';
export const SET_PROJECT_DATA_REQUEST = 'SET_PROJECT_DATA_REQUEST';
export const SET_PROJECT_RESPONSIBLE_REQUEST = 'SET_PROJECT_RESPONSIBLE_REQUEST';
export const SET_PROJECT_ASSIGNEES_REQUEST = 'SET_PROJECT_ASSIGNEES_REQUEST';
export const CREATE_PROJECT_REQUEST = 'CREATE_PROJECT_REQUEST';
export const UPDATE_PROJECT_STATUS_REQUEST = 'UPDATE_PROJECT_STATUS_REQUEST';
export const DELETE_PROJECT_ASSIGNEE_REQUEST = 'DELETE_PROJECT_ASSIGNEE_REQUEST';
export const COMPLETE_PROJECT_REQUEST = 'COMPLETE_PROJECT_REQUEST';
export const DELETE_PROJECT_REQUEST = 'DELETE_PROJECT_REQUEST';
export const RESTORE_PROJECT_REQUEST = 'RESTORE_PROJECT_REQUEST';
export const GET_PROJECT_MOVE_PREVIEW_REQUEST = 'GET_PROJECT_MOVE_PREVIEW_REQUEST';
export const MOVE_PROJECT_REQUEST = 'MOVE_PROJECT_REQUEST';
export const AUTHORIZE_PROJECT_REQUEST = 'AUTHORIZE_PROJECT_REQUEST';
export const REJECT_PROJECT_REQUEST = 'REJECT_PROJECT_REQUEST';

export const getProjectSummary = (callback) => ({
    type: GET_PROJECT_SUMMARY_REQUEST,
    payload: { callback }
});

export const getMonthlyStatusBreakdown = (months = 6, callback) => ({
    type: GET_MONTHLY_STATUS_BREAKDOWN_REQUEST,
    payload: { months, callback }
});

export const getUnassignedSummary = (callback) => ({
    type: GET_UNASSIGNED_SUMMARY_REQUEST,
    payload: { callback }
});

export const getUnassignedList = (type, cell, start, callback) => ({
    type: GET_UNASSIGNED_LIST_REQUEST,
    payload: { type, cell, start, callback }
});

export const getProject = (projectId, callback) => ({
    type: GET_PROJECT_REQUEST,
    payload: { projectId, callback }
});

export const getProjects = (start, limit, state = 'open', filters = {}, callback) => ({
    type: GET_PROJECTS_REQUEST,
    payload: { start, limit, state: 'open', filters: {}, callback },
});

export const getProjectBillingEntities = (callback) => ({
    type: GET_PROJECT_BILLING_ENTITIES_REQUEST,
    payload: { callback },
});

export const setUpdateProject = (projectId, projectData, callback) => ({
    type: SET_PROJECT_DATA_REQUEST,
    payload: { projectId, projectData, callback },
});

export const setProjectResponsible = (projectId, responsible, callback) => ({
    type: SET_PROJECT_RESPONSIBLE_REQUEST,
    payload: { projectId, responsible, callback },
});

export const setProjectAssignees = (projectId, assignees, callback) => ({
    type: SET_PROJECT_ASSIGNEES_REQUEST,
    payload: { projectId, assignees, callback },
});

export const createProject = (projectData, callback) => ({
    type: CREATE_PROJECT_REQUEST,
    payload: { projectData, callback },
});

export const updateProjectStatus = (projectId, status, callback) => ({
    type: UPDATE_PROJECT_STATUS_REQUEST,
    payload: { projectId, status, callback },
});

export const deleteProjectAssignee = (projectId, assignees, callback) => ({
    type: DELETE_PROJECT_ASSIGNEE_REQUEST,
    payload: { projectId, assignees, callback },
});

export const completeProject = (projectId, callback) => ({
    type: COMPLETE_PROJECT_REQUEST,
    payload: { projectId, callback },
});

export const deleteProject = (projectId, callback) => ({
    type: DELETE_PROJECT_REQUEST,
    payload: { projectId, callback },
});

export const restoreProject = (projectId, callback) => ({
    type: RESTORE_PROJECT_REQUEST,
    payload: { projectId, callback },
});

export const getProjectMovePreview = (projectId, accountId, callback) => ({
    type: GET_PROJECT_MOVE_PREVIEW_REQUEST,
    payload: { projectId, accountId, callback },
});

export const moveProject = (projectId, accountId, callback) => ({
    type: MOVE_PROJECT_REQUEST,
    payload: { projectId, accountId, callback },
});

export const authorizeProject = (projectId, callback) => ({
    type: AUTHORIZE_PROJECT_REQUEST,
    payload: { projectId, callback },
});

export const rejectProject = (projectId, callback) => ({
    type: REJECT_PROJECT_REQUEST,
    payload: { projectId, callback },
});
